import qs from 'query-string';
import React from 'react';
import { useHistory } from 'react-router-dom';

import SearchModal from './SearchModal';
import { getEntityCatalog } from '../api/forms';
import { ENTITIES_LABEL } from '../constants/EntitiesModalConstants';
import { SAVED_SEARCH_EDITOR } from '../constants/Urls';
import { useTranslation } from '../custom-hooks/useTranslation';
import {
  modifyCreateSavedSearchEntities,
  modifyEntityCatalogItems,
} from '../utils/entitiesListUtils';

const getNewSavedSearchLink = ({ entityName, viewName, translatedEntityName }) => {
  const newEntityParams = {
    entityName,
    translatedEntityName,
    viewName,
    isNew: true,
    standaloneLayout: true,
  };
  const stringifyParams = qs.stringify(newEntityParams);

  return `${SAVED_SEARCH_EDITOR}?${stringifyParams}`;
};

const NewSavedSearchDialog = ({ open, handleClose }) => {
  const history = useHistory();
  const translateString = useTranslation();

  const loadEntities = async () => {
    const response = await getEntityCatalog();
    if (!response.hasError) {
      const {
        entityCatalog: { Entity },
      } = response;

      return modifyEntityCatalogItems({ entities: Entity });
    }
  };

  const handleCreateButtonClick = (selectedEntity) => {
    handleClose();

    history.push(
      getNewSavedSearchLink({
        entityName: selectedEntity.id,
        translatedEntityName: selectedEntity.translatedEntityName,
        viewName: selectedEntity.viewName,
      })
    );
  };

  return (
    <SearchModal
      open={open}
      modalTitle="Create Saved Search"
      closeModal={handleClose}
      onConfirm={handleCreateButtonClick}
      confirmButtonLabel={translateString('Create')}
      fetchData={loadEntities}
      modifyListItems={modifyCreateSavedSearchEntities}
      defaultItemExpanded={[ENTITIES_LABEL]}
    />
  );
};

export default NewSavedSearchDialog;
